const data = [
    {
        year: "2023-24",
        pdf :"",
        title:"Annual Report 2023-24"
    },
    {
        year: "2022-23",
        pdf :"https://res.cloudinary.com/dptdrzycj/image/upload/v1704454236/Annual_Report_2022-23_gmrgb3.pdf",
        title:"Annual Report 2022-23"
    },
    {
        year: "2021-2022",
        pdf :"https://res.cloudinary.com/dptdrzycj/image/upload/v1704454209/SAIT_Report_on_Major_Events_AY_2021-22_1_jk3ipm.pdf",
        title:"Annual Report 2021-22"
    }
    ,{
        year: "2020-21",
        pdf :"https://res.cloudinary.com/dptdrzycj/image/upload/v1704454178/SAIT20-21_ibewnz.pdf",
        title:"Annual Report 2020-21"
    },
    {
        year: "2019-2020",
        pdf :"https://res.cloudinary.com/dptdrzycj/image/upload/v1704454130/SAIT19-20_2_pcjduu.pdf",
        title:"Annual Report 2019-20"
    },{
        year: "2018-2019",
        pdf :"https://res.cloudinary.com/dptdrzycj/image/upload/v1704454088/SAIT18-19_2_z79wpn.pdf",
        title:"Annual Report 2018-19"
    }
]
export default data;